import React from 'react';

import { IconWorldUpload } from '@tabler/icons-react';
import { DroxyModal, DroxyModalProps } from 'components/Droxy/DroxyModal';
import { SmartAssistantWebsiteCodeSnipet } from 'components/SmartAssistantWebsiteCodeSnipet';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface EmbedSmartAssistantWebsiteModalProps extends DroxyModalProps {
  smartAssistant: SmartAssistant;
}

export function EmbedSmartAssistantWebsiteModal({
  smartAssistant,
  ...appModalProps
}: EmbedSmartAssistantWebsiteModalProps) {
  const { t } = useTranslation();

  return (
    <DroxyModal
      size="lg"
      title={t('SMART_ASSISTANT.EMBED_WEBSITE.TITLE')}
      description={t('SMART_ASSISTANT.EMBED_WEBSITE.DESCRIPTION')}
      titleIcon={<IconWorldUpload />}
      {...appModalProps}>
      <SmartAssistantWebsiteCodeSnipet
        smartAssistantId={smartAssistant._id}
        whiteLabelIntegration={smartAssistant.whiteLabelIntegration}
      />
    </DroxyModal>
  );
}
